// Normalise a translation key to camelCase: collapses snake_case / kebab-case
// per dot-segment (dots kept). Idempotent; leaves PascalCase/acronyms/digits
// untouched. Applied on both backend load and t() lookup (see src/i18n.js).
const camelizeSegment = (segment) =>
    segment
        .replace(/[_-]+([a-zA-Z0-9])/g, (_match, char) => char.toUpperCase())
        .replace(/[_-]+$/, '');

export const camelizeTranslationKey = (key) => {
    if (typeof key !== 'string' || !key) return key;
    if (key.indexOf('_') === -1 && key.indexOf('-') === -1) return key;
    return key.split('.').map(camelizeSegment).join('.');
};
